// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

body {
    margin: 0;
    padding: 0;
    background-color: #333;
    color: #fff;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
}

.main-section {
    position: relative;
    z-index: 1;
}

.heading {
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
}

.spin-button {
    display: block;
    margin: 0 auto;
    width: 200px;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    height: 55px;
    text-align:center;
    border: none;
    background-size: 300% 100%;
    border-radius: 50px;
    transition: all 0.4s ease-in-out;
}

.spin-button:hover {
    background-position: 100% 0;
    transition: all 0.4s ease-in-out;
}

.spin-button:focus {
    outline: none;
}

.spin-button:disabled {
    cursor: not-allowed;
}

.spin-button {
    background-image: linear-gradient(to right, #fc6076, #ff9a44, #ef9d43, #e75516);
    box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}

#particles-js {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    z-index: 0;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+EAA+E;IAC/E,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    background-color: #333;\n    color: #fff;\n    font-family: \"Roboto\", sans-serif;\n    font-weight: 400;\n}\n\n.main-section {\n    position: relative;\n    z-index: 1;\n}\n\n.heading {\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 15px;\n}\n\n.spin-button {\n    display: block;\n    margin: 0 auto;\n    width: 200px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #fff;\n    cursor: pointer;\n    height: 55px;\n    text-align:center;\n    border: none;\n    background-size: 300% 100%;\n    border-radius: 50px;\n    transition: all 0.4s ease-in-out;\n}\n\n.spin-button:hover {\n    background-position: 100% 0;\n    transition: all 0.4s ease-in-out;\n}\n\n.spin-button:focus {\n    outline: none;\n}\n\n.spin-button:disabled {\n    cursor: not-allowed;\n}\n\n.spin-button {\n    background-image: linear-gradient(to right, #fc6076, #ff9a44, #ef9d43, #e75516);\n    box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);\n}\n\n#particles-js {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    inset: 0;\n    z-index: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
